import Carga from '@/model/resource/Carga'
import DeliverySacAgcoReportSchema from '@/schema/DeliverySacAgcoReport.schema'
import {ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import SacResponse from '@/model/response/SacResponse'

export default class DeliverySacAgcoResponse extends Carga {

    readonly $name: string = 'DeliverySacAgcoResponse'
    readonly $endpoint: string = '/user/agco/sac/report'

    get $id() {
        return this.id
    }
    set $id(val: ID) {
        this.id = val
    }

    get $schema() {
        return DeliverySacAgcoReportSchema(this)
    }

    id: ID = 0

    @ResponseSerialize(SacResponse)
    sacResponse: SacResponse | null = null

}
